export const ICON_BASE_SIZE = 1
